import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';

import {GeoJson} from './map';


@Injectable()
export class ApiService {
  private apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
  ) {
    // todo choose correct protocol etc in a nicer way...
    if (!this.apiUrl.startsWith('http')) {
      this.apiUrl = `http://${this.apiUrl}`;
    }
  }

  getGeoJson(year: string, name: string): Observable<GeoJson> {
    return this.http.get<GeoJson>(`${this.apiUrl}/geo/${year}/${name}`);
  }

}



// WEBPACK FOOTER //
// /app/src/app/api.service.ts